module.exports = __webpack_public_path__ + "static/media/hong-kong.ab9cf218.jpg";